<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Quiz Groups</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createnew">
                Create Group
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>
        
        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="persons" header="Participants" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                <PrimeButton
                    label="Participants"
                    icon="pi-file-o"
                    class="p-button-rounded p-button-text"
                    @click="showGroups(slotProps.data)"
                />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="addGroup"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>

</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref,computed} from 'vue';
import { useRouter, useRoute } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";

export default {
    name:"AcademicResults",
    components:{ModalView,DynamicForm},
    setup(){
        const route = useRoute();
        const qid = computed(() => route.params.id);
        const router = useRouter();
        const state=reactive({loading:true,createModal:false,submitting:false,errors:[],success:false })
        const list = ref([])
        const globalFilter=ref("")
        onMounted(() => {
            call({
                url:urls.quiz,
                data:{getQuizGroup:qid.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        if (!Array.isArray(res.msg)) {
                            list.value = Object.values(res.msg)
                        } else {
                            list.value = res.msg
                        }
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        const createFields=ref([
            { name: "Create Group", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Name',
                        value: ""  },
                    {type: 'hidden', name:"addGroup", value:qid.value}
                ]
            }
        ])

        function createnew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
        }

        
        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        function addGroup(data){
            state.submitting=true;
            state.errors=[];
            state.success=false;
            call({
                url:urls.quiz,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function action(row,type){
            console.log(type, row)
            router.push({ name: 'resultsview', query: { stu: row.id, s:type } });
        }

        function showGroups(row){
            router.push({ name: 'quizgroup', params: { stu: row.id} });
        }
        
        return {list,globalFilter, state,action,createFields,createnew,addGroup, showGroups}
    }
}
</script>